import Keycloak from "keycloak-js/dist/keycloak.js";

export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
//export const keycloakUrl = "http://localhost:8080/auth/";

const keycloakData = {
    realm: "streetscooter",
    url: keycloakUrl,
    clientId: "analysisframework"
};

export const keycloak = new Keycloak(keycloakData);
